module.exports = __webpack_public_path__ + "images/home/index/values-growth-screenshot-c064c71edb3199d393fa70de506770c6.png";